import { render } from "./AsideDashComponent.vue?vue&type=template&id=6daa3741&scoped=true"
import script from "./AsideDashComponent.vue?vue&type=script&lang=js"
export * from "./AsideDashComponent.vue?vue&type=script&lang=js"

import "./AsideDashComponent.vue?vue&type=style&index=0&id=6daa3741&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\WEB-SITE-DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6daa3741"]])

export default __exports__